export const resolveCartProperties = (propProperties, contextProperties) => {
  const merged = new Map();
  for (const property of [
    ...(Array.isArray(contextProperties) ? contextProperties : []),
    ...(Array.isArray(propProperties) ? propProperties : []),
  ]) {
    if (property?.id != null) merged.set(String(property.id), property);
  }
  return Array.from(merged.values());
};
